export type EncouragementTier = "incredible" | "inspiring" | "almostThere" | "beautifulStart" | "meansSoMuch";

export const getEncouragementTier = (contributionPercentage: number, campaignPercentage: number): EncouragementTier => {
  if (contributionPercentage >= 10) {
    return "incredible";
  }
  if (contributionPercentage >= 3) {
    return "inspiring";
  }
  if (campaignPercentage > 90 && campaignPercentage < 100) {
    return "almostThere";
  }
  if (campaignPercentage < 20) {
    return "beautifulStart";
  }
  return "meansSoMuch";
};
